import {
  DEFAULT_SEO_DESCRIPTION,
  DEFAULT_SEO_TITLE,
} from '../../../lib/consts';
import { GB_DOMAIN } from '../../../lib/api/apiUrl';
import { City } from '../../../models';
import { FilterQuery } from '../../../models/filters';
import { Category } from '../../../models/action';

export function getSeoParams(
  currentCity: City,
  categories: Category[],
  query: FilterQuery
) {
  const isNotFirstPage =
    query.filters.pages.length > 1 && Number(query.filters.pages[1]) !== 1;
  const { pages } = query.filters;
  const prepositionalNameOfCity = currentCity.prepositional_name;

  const getDefaultSeoParams = () => ({
    title: DEFAULT_SEO_TITLE,
    description: DEFAULT_SEO_DESCRIPTION,
    h1: 'Каталог',
    canonicalLink: `${GB_DOMAIN}/${currentCity.url}/catalog/`,
  });

  const getCatalogSeoParams = (categoryTitle: any, canonical = null) => ({
    title: `${categoryTitle} - страница ${
      pages[0] === pages[1] ? `№${pages[1]}` : `№${pages[0]}-${pages[1]}`
    } | билеты на сайте Горбилет${
      prepositionalNameOfCity ? ` в ${prepositionalNameOfCity}` : ''
    }`,
    description: `${categoryTitle} - страница ${
      pages[0] === pages[1] ? `№${pages[1]}` : `№${pages[0]}-${pages[1]}`
    } билеты в каталоге на сайте Горбилет со скидкой${
      prepositionalNameOfCity ? ` в ${prepositionalNameOfCity}` : ''
    }`,
    h1: `${categoryTitle} - страница ${
      pages[0] === pages[1] ? `№${pages[1]}` : `№${pages[0]}-${pages[1]}`
    }`,
    canonicalLink: canonical || `${GB_DOMAIN}/${currentCity.url}/catalog/`,
  });

  if (typeof query.filters.categories.category !== 'number') {
    return isNotFirstPage
      ? getCatalogSeoParams('Каталог', null)
      : getDefaultSeoParams();
  }

  const currentCategory = categories.find(
    (category: any) => category.id === query.filters.categories.category
  );
  if (!currentCategory) {
    return isNotFirstPage
      ? getCatalogSeoParams('Каталог', null)
      : getDefaultSeoParams();
  }

  if (currentCategory.children.length === 1) {
    const childrenCategory = currentCategory.children.find(
      (subcategory: any) =>
        subcategory.id === query.filters.categories.subcategories[0]
    );
    if (!childrenCategory) {
      return isNotFirstPage
        ? getCatalogSeoParams('Каталог', null)
        : getDefaultSeoParams();
    }
    return isNotFirstPage
      ? getCatalogSeoParams(
          childrenCategory.seo_h1 || childrenCategory.title,
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          `${GB_DOMAIN}/${currentCity.url}/catalog/${currentCategory.slug}/${childrenCategory.slug}/`
        )
      : {
          title: childrenCategory.seo_title || childrenCategory.title,
          description:
            childrenCategory.seo_description || DEFAULT_SEO_DESCRIPTION,
          h1: childrenCategory.seo_h1 || childrenCategory.title,
          canonicalLink: `${GB_DOMAIN}/${currentCity.url}/catalog/${currentCategory.slug}/${childrenCategory.slug}/`,
        };
  }

  if (
    currentCategory.children.length ===
    query.filters.categories.subcategories.length
  ) {
    return isNotFirstPage
      ? getCatalogSeoParams(
          currentCategory.seo_h1 || currentCategory.title,
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          `${GB_DOMAIN}/${currentCity.url}/catalog/${currentCategory.slug}/`
        )
      : {
          title: currentCategory.seo_title || currentCategory.title,
          description:
            currentCategory.seo_description || DEFAULT_SEO_DESCRIPTION,
          h1: currentCategory.seo_h1 || currentCategory.title,
          canonicalLink: `${GB_DOMAIN}/${currentCity.url}/catalog/${currentCategory.slug}/`,
        };
  }

  if (query.filters.categories.subcategories.length === 1) {
    const childrenCategory = currentCategory.children.find(
      (subcategory: any) =>
        subcategory.id === query.filters.categories.subcategories[0]
    );
    if (!childrenCategory) {
      return isNotFirstPage
        ? getCatalogSeoParams('Каталог', null)
        : getDefaultSeoParams();
    }
    return isNotFirstPage
      ? getCatalogSeoParams(
          childrenCategory.seo_h1 || childrenCategory.title,
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          `${GB_DOMAIN}/${currentCity.url}/catalog/${currentCategory.slug}/${childrenCategory.slug}/`
        )
      : {
          title: childrenCategory.seo_title || childrenCategory.title,
          description:
            childrenCategory.seo_description || DEFAULT_SEO_DESCRIPTION,
          h1: childrenCategory.seo_h1 || childrenCategory.title,
          canonicalLink: `${GB_DOMAIN}/${currentCity.url}/catalog/${currentCategory.slug}/${childrenCategory.slug}/`,
        };
  }

  return isNotFirstPage
    ? getCatalogSeoParams(
        currentCategory.seo_h1 || currentCategory.title,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        `${GB_DOMAIN}/${currentCity.url}/catalog/${currentCategory.slug}/`
      )
    : {
        title: currentCategory.seo_title || currentCategory.title,
        description: currentCategory.seo_description || DEFAULT_SEO_DESCRIPTION,
        h1: currentCategory.seo_h1 || currentCategory.title,
        canonicalLink: `${GB_DOMAIN}/${currentCity.url}/catalog/${currentCategory.slug}/`,
      };
}
